import { createIcon } from '../createIcon';

export const HamburgerIcon = createIcon({
  viewBox: '0 0 24 24',
  d:
    'M22 5H2V7.47961H22V5ZM22 10.4795H2V12.9591H22V10.4795ZM2 15.959H22V18.4386H2V15.959Z',
});
